import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage, requiredValidator } from '@scisys-uim/uim-common';
import { AssetsUser, FIREARM_ASSIGNMENT_LOG_TYPE, FIREARM_METADATA, FIREARM_TYPE, Firearm, FirearmAssignmentLog, setDefaultLocationFromUser } from 'assets-model';
import { FirearmAssignmentLogService, FirearmService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class FirearmAssignmentLogItemComponentBase extends CrudItemComponent<FirearmAssignmentLog, number> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  
  firearmSelectionList: Firearm[];


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected firearmAssignmentLogService: FirearmAssignmentLogService,
    protected firearmService: FirearmService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(FIREARM_ASSIGNMENT_LOG_TYPE, fb, elementRef, router, route, userStorage, dialog, firearmAssignmentLogService, injector, snackbar);
  }

  createNewItem() {
    return new FirearmAssignmentLog();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      assetId: [null, []],
      firearm: [null, [requiredValidator,]],
      acquireAssignmentId: [null, []],
      businessUnit: [null, []],
      currentAssignmentId: [null, []],
      currentlyAssignable: [null, []],
      disposeAssignmentId: [null, []],
      lifecycleState: [null, []],
      pendingActions: [null, []],
      pendingActionsCount: [null, []],
      poolFirearm: [null, []]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      setDefaultLocationFromUser(this.userDetails, this.item);

      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.assetId?.disable();
    }
    this.acquireAssignmentId?.disable();
    this.businessUnit?.disable();
    this.currentAssignmentId?.disable();
    this.currentlyAssignable?.disable();
    this.disposeAssignmentId?.disable();
    this.lifecycleState?.disable();
    this.pendingActions?.disable();
    this.pendingActionsCount?.disable();
    this.poolFirearm?.disable();
  }
  
  assetIdChanging(value: number, unsetDependents: boolean = true) {}
  
  assetIdChanged(value: number, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.assetIdChangedByUser(value, unsetDependents);
    }
  }  
  
  assetIdChangedByUser(value: number, unsetDependents: boolean = true) {
  }
  
  firearmDisplay(item: Firearm) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return FIREARM_TYPE.description(item);
  }
  
  firearmLoadSelectionList() {
    this.firearmService.findAll().subscribe(
      data => {
        this.firearmSelectionList = FIREARM_TYPE.entityDecorator.ensureContained(this.item && this.item.firearm, data.items);
      }
    );
  }

  firearmChanging(value: Firearm, unsetDependents: boolean = true) {}
  
  firearmChanged(value: Firearm, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.firearmChangedByUser(value, unsetDependents);
    }
  }  
  
  firearmChangedByUser(value: Firearm, unsetDependents: boolean = true) {
  }
  
  firearmCompare(a: any, b: any) {
    return FIREARM_METADATA.equals(a, b);
  }
  
  
  
  
  
  
  
  
  
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get assetId() {
    return this.control('assetId');
  }
  
  get firearm() {
    return this.control('firearm');
  }
  
  get acquireAssignmentId() {
    return this.control('acquireAssignmentId');
  }
  
  get businessUnit() {
    return this.control('businessUnit');
  }
  
  get currentAssignmentId() {
    return this.control('currentAssignmentId');
  }
  
  get currentlyAssignable() {
    return this.control('currentlyAssignable');
  }
  
  get disposeAssignmentId() {
    return this.control('disposeAssignmentId');
  }
  
  get lifecycleState() {
    return this.control('lifecycleState');
  }
  
  get pendingActions() {
    return this.control('pendingActions');
  }
  
  get pendingActionsCount() {
    return this.control('pendingActionsCount');
  }
  
  get poolFirearm() {
    return this.control('poolFirearm');
  }
  
}





